import { render, staticRenderFns } from "./reset-password-container.vue?vue&type=template&id=1a2d63fe&"
import script from "./reset-password-container.vue?vue&type=script&lang=js&"
export * from "./reset-password-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports